import {
	applyGuestPlanFilter,
	focusGuestPlan,
	openGuestPlanSection,
} from './adapter';
import {
	openGuestPlanCreateModal,
	openGuestPlanDeleteModal,
	openGuestPlanEditModal,
} from './modal';
import {resolveGuestPlans} from './resolver';

/**
 * Guest Access Plans.
 *
 * The list on IO-Pass Configuration, and a record collection in its own
 * right rather than a section of that tab - the same reading Captive Portals
 * already has, and for the same reason: the accordion has a search box and
 * an Add button, and every row offers Edit and Delete. A plan decides how
 * long a guest may stay on, how long the plan itself stays valid, how fast
 * the connection is and how much the guest may transfer.
 *
 * The three row actions end at a form: the agent opens it and a person fills
 * it in, which is where open-only stops. Canvas itself refuses to edit or
 * delete the plan named Default_Plan, and the handlers report that back
 * rather than opening nothing.
 */
const guestPlanPlugin = {
	id: 'guest_plan',
	version: 1,
	commandVersion: 1,
	resource: 'guest_plan',
	operations: ['options', 'view', 'search', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation', 'guest_config'],
		destinations: ['iopass.dashboard'],
	},
	sections: {
		'iopass.guest_plans': openGuestPlanSection,
	},
	resolvers: {
		guest_plan: resolveGuestPlans,
	},
	filters: {
		guest_plan: applyGuestPlanFilter,
	},
	focusHandlers: {
		guest_plan: focusGuestPlan,
	},
	modals: {
		'guest_plan.create': openGuestPlanCreateModal,
		'guest_plan.edit': openGuestPlanEditModal,
		'guest_plan.delete': openGuestPlanDeleteModal,
	},
};

export default guestPlanPlugin;
